var bodyScrollLockOptions = {
  reserveScrollBarGap: true
};

// Define global parser for loadmore functionality
if (typeof parser === 'undefined') {
  var parser = new DOMParser();
}

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Drawer {
  constructor(element, options = {}) {
    this.element = element;
    this.onDrawerClose = options.onDrawerClose || (() => { });
    this.onDrawerOpen = options.onDrawerOpen || (() => { });
    this.pageOverlayElement = document.querySelector("overlay-opacity");
    this.isOpen = false;
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this._toggleListener = this.toggleDrawer.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    const toggleId = this.element.id;

    document.querySelectorAll(`[data-action="open-drawer"][data-toggle-id="${toggleId}"]`)
      .forEach(el => el.addEventListener("click", this._openListener));

    document.querySelectorAll(`[data-action="close-drawer"][data-toggle-id="${toggleId}"]`)
      .forEach(el => el.addEventListener("click", this._closeListener));

    document.querySelectorAll(`[data-action="toggle-drawer"][data-toggle-id="${toggleId}"]`)
      .forEach(el => el.addEventListener("click", this._toggleListener));
  }

  toggleDrawer(event) {
    event.preventDefault();
    this.isOpen ? this.closeDrawer(event) : this.openDrawer(event);
  }

  openDrawer(event) {
    if (this.isOpen) return false;

    this.focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(this.focus, bodyScrollLockOptions);
    document.body.classList.add("open-canvas");

    this.pageOverlayElement.addEventListener("click", this._closeListener);

    this.element.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      this.element.setAttribute("aria-expanded", "true");
    });

    this.onDrawerOpen();
    trapFocus(this.element);

    this.isOpen = true;
  }

  closeDrawer(event) {
    if (!this.isOpen) return;

    if (event) {
      event.preventDefault();
      this.eventTarget = event.target;
      this.eventTarget.classList.add('is-disabled');
    }

    this.element.setAttribute("aria-expanded", "false");
    document.body.classList.remove("open-canvas");

    this._transitionEndHandler = this.handleTransitionEnd.bind(this);
    this.element.addEventListener("animationend", this._transitionEndHandler);
    this.pageOverlayElement.removeEventListener("click", this._closeListener);

    this.onDrawerClose();
    removeTrapFocus(this.element);

    this.isOpen = false;
  }

  handleTransitionEnd(event) {
    if (event.target !== this.element) return;

    this.element.setAttribute("aria-hidden", "true");

    bodyScrollLock.enableBodyScroll(this.focus, bodyScrollLockOptions);

    this.element.removeEventListener("animationend", this._transitionEndHandler);
  }
}

class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.open = false;
    this.favoritesCache = new Map();
    this._toggleFavoriteListener = this.toggleFavorite.bind(this);
  }

  connectedCallback() {
    this.initializeDrawer();
    this.cacheDOMElements();
    this.previousLocalStorageValue = localStorage.getItem("productFavorites");

    this.rerenderFavorites();
    this.updateFavoritesAcrossSite();
    this.bindEvents();
    this.initializeParticles();
  }

  disconnectedCallback() {
    this.removeEvents();
    if (this.favoritesDrawer) {
      this.favoritesDrawer.removeEvents();
    }
  }

  initializeDrawer() {
    this.favoritesDrawer = new Drawer(this.element, {
      onDrawerClose: () => {
        this.open = false;
        this.previousLocalStorageValue = localStorage.getItem("productFavorites");
      },
      onDrawerOpen: () => {
        if (this.previousLocalStorageValue !== localStorage.getItem("productFavorites")) {
          this.rerenderFavorites(true, true);
        }
        this.open = true;
      }
    });
  }

  cacheDOMElements() {
    this.options = JSON.parse(this.element.getAttribute("data-settings") || "{}");
    this.favPopulated = document.querySelectorAll(".header__favorites--populated");
    this.contentElement = document.querySelector(".favorites__content");
    this.loader = this.element.querySelector(".spinning-loader");
  }

  initializeParticles() {
    // Create particles container for each favorites icon
    document.querySelectorAll('[data-action="toggle-favorites"]').forEach(icon => {
      // Only add particles if they don't exist yet
      if (!icon.querySelector('.particles')) {
        const particlesContainer = document.createElement('div');
        particlesContainer.classList.add('particles');

        // Create 10 particles for each heart
        for (let i = 0; i < 10; i++) {
          const particle = document.createElement('div');
          particle.classList.add('particle');
          particlesContainer.appendChild(particle);
        }

        icon.appendChild(particlesContainer);
      }
    });
  }

  bindEvents() {
    document.querySelectorAll('[data-action="toggle-favorites"]').forEach(el => {
      el.addEventListener("click", this._toggleFavoriteListener);
      el.addEventListener("keydown", this._toggleFavoriteListener);
    });
  }

  removeEvents() {
    document.querySelectorAll('[data-action="toggle-favorites"]').forEach(el => {
      el.removeEventListener("click", this._toggleFavoriteListener);
      el.removeEventListener("keydown", this._toggleFavoriteListener);
    });
  }

  toggleFavorite(e) {
    if (e.key && e.key !== "Enter") return;
    e.preventDefault();

    const target = e.target;
    const favIcon = target.closest('[data-action="toggle-favorites"]');
    if (!favIcon) return;

    const productId = favIcon.getAttribute("data-id");

    if (!productId) return;
    const items = this.getFavorites();
    const existingItemIndex = items.findIndex(id => id === productId);

    const solidFavorite = favIcon.querySelector(".solid-favorite");
    const emptyFavorite = favIcon.querySelector(".empty-favorite");

    if (existingItemIndex === -1) {
      // Add to favorites
      items.unshift(productId);
      this.saveFavorites(items);

      // Reset classes
      solidFavorite.classList.remove('heart-animation-out');

      // Show the solid heart with animation
      solidFavorite.classList.add('heart-animation');

      // Hide empty heart (with opacity)
      emptyFavorite.style.opacity = "0";

      // Animate particles
      this.animateParticles(favIcon);

      if (this.open) {
        this.rerenderFavorites(true);
      }
    } else {
      // Remove from favorites
      const updatedItems = items.filter(id => id !== productId);
      this.saveFavorites(updatedItems);

      // Animate out the solid heart
      solidFavorite.classList.remove('heart-animation');
      solidFavorite.classList.add('heart-animation-out');

      // Show empty heart (with opacity)
      emptyFavorite.style.opacity = "1";

      // Listen for animation end to fully reset
      solidFavorite.addEventListener('animationend', () => {
        if (solidFavorite.classList.contains('heart-animation-out')) {
          solidFavorite.classList.remove('heart-animation-out');
        }
      }, { once: true });

      if (this.open) {
        this.removeSingleFavorite(productId);
      }

      if (updatedItems.length === 0) {
        this.rerenderFavorites(true);
      }
    }

    // Update state attribute for accessibility
    favIcon.setAttribute("state", existingItemIndex === -1 ? "active" : "not-active");
  }

  animateParticles(favIcon) {
    const particles = favIcon.querySelectorAll('.particle');

    particles.forEach((particle, index) => {
      // Calculate random direction for each particle
      const angle = Math.random() * Math.PI * 2;
      const distance = 10 + Math.random() * 30;
      const tx = Math.cos(angle) * distance;
      const ty = Math.sin(angle) * distance;

      // Set custom properties for the particle animation
      particle.style.setProperty('--tx', `${tx}px`);
      particle.style.setProperty('--ty', `${ty}px`);

      // Reset and trigger animation
      particle.classList.remove('animate');
      setTimeout(() => {
        particle.classList.add('animate');
      }, index * 20);
    });
  }

  removeSingleFavorite(productId) {
    const productCardToRemove = this.contentElement.querySelector(`#favorites__grid-item--${productId}`);
    if (!productCardToRemove) return;

    const solidFavorite = productCardToRemove.querySelector(".solid-favorite");
    const emptyFavorite = productCardToRemove.querySelector(".empty-favorite");
    emptyFavorite.style.opacity = "1";
    solidFavorite.style.transform = "scale(0)";
    solidFavorite.style.opacity = "0";

    setTimeout(() => {
      productCardToRemove.classList.add('removing');
      productCardToRemove.addEventListener('transitionend', () => {
        setTimeout(() => {
          productCardToRemove.remove();
        }, 100);
      }, { once: true });
    }, 200);
  }

  updateFavoritesAcrossSite() {
    const items = this.getFavorites();
    const favorites = document.querySelectorAll('[data-action="toggle-favorites"]');

    const hasItems = items.length > 0;
    this.favPopulated.forEach(item => {
      item.style.opacity = hasItems ? "1" : "0";
    });

    favorites.forEach(item => {
      const productId = item.getAttribute("data-id");
      const isFavorite = items.some(id => id === productId);
      const solidFavorite = item.querySelector(".solid-favorite");
      const emptyFavorite = item.querySelector(".empty-favorite");

      if (solidFavorite && emptyFavorite) {
        // Use opacity instead of display
        if (isFavorite) {
          // Product is favorited
          solidFavorite.style.opacity = "1";
          solidFavorite.style.transform = "scale(1)";
          emptyFavorite.style.opacity = "0";
        } else {
          // Product is not favorited
          solidFavorite.style.opacity = "0";
          solidFavorite.style.transform = "scale(0)";
          emptyFavorite.style.opacity = "1";
        }

        item.setAttribute("state", isFavorite ? "active" : "not-active");

        // Reset animation classes
        solidFavorite.classList.remove('heart-animation', 'heart-animation-out');
      }
    });

    // Initialize particles after updating favorites
    this.initializeParticles();
  }

  saveFavorites(items) {
    localStorage.setItem("productFavorites", JSON.stringify(items.slice(0, 50)));
    this.updateFavoritesAcrossSite();
  }

  getFavorites() {
    return JSON.parse(localStorage.getItem("productFavorites") || "[]")
      .filter(item => item && item.id !== null);
  }

  hideLoader(useLoader) {
    if (!useLoader) {
      this.contentElement.style.opacity = "1";
    }
    this.loader.classList.remove("is-visible");
  }

  async rerenderFavorites(useLoader = true, skip) {
    if (!skip) {
      await new Promise(resolve => setTimeout(resolve, 200));
    }

    if (useLoader) {
      this.loader.classList.add("is-visible");
    } else {
      this.contentElement.style.opacity = "0";
    }

    const queryStrings = this.getSearchQueryStrings();

    if (queryStrings.length === 0) {
      try {
        const response = await fetch(`${window.routes.localeRootUrl}/?section_id=favorites-drawer`);
        const html = await response.text();
        await this.appendContent(html, true);
        this.hideLoader(useLoader);
      } catch (error) {
        console.error("Error fetching main favorites section:", error);
      }
      return;
    }

    try {
      const promises = queryStrings.map(queryString =>
        this.fetchFavorites(queryString)
      );

      let isFirst = true;
      for (const promise of promises) {
        const html = await promise;
        this.appendContent(html, false, isFirst);
        isFirst = false;
      }

      this.hideLoader(useLoader);
    } catch (error) {
      console.error("Error fetching favorites:", error);
      this.hideLoader(useLoader);
    }
  }

  async fetchFavorites(queryString) {
    if (this.favoritesCache.has(queryString)) {
      return this.favoritesCache.get(queryString);
    }

    const url = `${window.routes.localeRootUrl}/search?view=favorites&type=product&q=${queryString}`;
    const response = await fetch(url, {
      credentials: "same-origin",
      method: "GET"
    });

    const html = await response.text();
    this.favoritesCache.set(queryString, html);

    return html;
  }

  appendContent(html, reset, isFirst = false) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    if (reset) {
      const newContent = tempElement.querySelector(".favorites__content");
      if (newContent) {
        this.contentElement.innerHTML = newContent.innerHTML;
      }
    } else {
      const newItems = tempElement.querySelector(".favorites__grid");
      if (!newItems) return;

      if (isFirst) {
        this.contentElement.innerHTML = "";
        this.contentElement.innerHTML = newItems.outerHTML;
      } else {
        const favoritesGrid = this.contentElement.querySelector(".favorites__grid");
        if (favoritesGrid) {
          favoritesGrid.innerHTML += newItems.innerHTML;
        }
      }
    }

    this.removeEvents();
    this.bindEvents();

    // Ensure particles are added to new favorites icons
    this.initializeParticles();
    this.updateFavoritesAcrossSite();
  }

  getSearchQueryStrings() {
    const items = this.getFavorites();
    const BATCH_SIZE = 10;

    return Array.from(
      { length: Math.ceil(items.length / BATCH_SIZE) },
      (_, i) => {
        const batch = items.slice(i * BATCH_SIZE, (i + 1) * BATCH_SIZE);
        return batch.map(id => `id:${id}`).join(" OR ");
      }
    );
  }
}

customElements.define("favorites-drawer", FavoritesDrawer);